export const MAIN_NAV_ITEM_CLASS_NAME =
  'flex items-center justify-center relative size-12 2xl:size-14 cursor-pointer text-slate-950 transition-colors text-2xl leading-none focus:outline-none focus-within:outline-none focus:text-white focus-within:text-white hover:text-white [&>*]:relative'

export const MAIN_NAV_ITEM_HOVER_CLASS_NAME =
  'before:content-[" "] before:absolute before:left-0 before:top-0 before:w-full before:h-full before:rounded-full before:bg-blue-600 before:opacity-0 before:scale-50 before:transition-all before:duration-300 hover:before:opacity-100 hover:before:scale-100 focus:before:opacity-100 focus:before:scale-100'

export const MAIN_NAV_ALERT_CLASS_NAME =
  'size-6 rounded-full !absolute flex items-center justify-center top-0 right-0 bg-amber-700 z-1 text-white text-xs'

export const DRAWER_LINK_CLASS_NAME =
  '!cursor-pointer w-full font-light flex items-center text-slate-950 px-2 py-3 xl:px-4 gap-x-2 rounded-lg hover:bg-neutral-100 focus:bg-neutral-100 transition-colors duration-300 leading-5 relative'

export const DRAWER_ACTIVE_LINK_CLASS_NAME =
  'font-medium bg-blue-100 hover:bg-blue-100 focus:bg-blue-100'

export const DRAWER_SUB_NAVIGATION_CLASS_NAME = 'py-2 rounded-l-none'
